import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import Checkbox from "@material-ui/core/Checkbox";
import SortingIndicator from "../common/SortingIndicator";


const ComponentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    height: fit-content;
`;

const HeadingsWrapper = styled.div`
    display: grid;
    
    align-items: center;
    grid-auto-flow: column;
    column-gap: 32px;
    //grid-template-columns: repeat(5, 150px);
    grid-template-columns: 100px 150px 100px 150px 150px 30px;

    > div {
      display: flex;
      align-items: center;
    }
`;

const HeadingWrapper = styled.button`
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    text-align: right;
    
    /* default/gray/900 */
    color: #1D2129;
    user-select: none;
    cursor: pointer;
    
    background: unset;
    border: unset;
    height: fit-content;
    display: flex;
    width: max-content;
    padding: unset;
    
    > * {
      margin-left: 8px;
    }
    
    :hover {
      color: #00AAF3;
    }
    
    :focus {
        outline: unset;
    }
`;

const HeadingContent = styled.div`
    display: flex;
    width: fit-content;
    position: relative;
    padding: 0 32px;
`;

function ContractsLineItemHeadings({selectable, isSelected, onSelected, indeterminate, onHeadingClick}) {
    return (
        <ComponentWrapper>
            {
                selectable &&
                <Checkbox
                    checked={isSelected}
                    onChange={onSelected}
                    indeterminate={indeterminate}
                    color="primary"
                    inputProps={{
                        'aria-label': 'primary checkbox',
                    }}
                />
            }
            <HeadingContent>
                <HeadingsWrapper>
                    {/*Id */}
                    <HeadingWrapper value="count" onClick={onHeadingClick}>
                        Contract
                        <SortingIndicator/>
                    </HeadingWrapper>
                    {/*Status*/}
                    <HeadingWrapper value="status" onClick={onHeadingClick}>
                        Status
                        <SortingIndicator/>
                    </HeadingWrapper>
                    {/*Duration*/}
                    <HeadingWrapper value="duration" onClick={onHeadingClick}>
                        Duration
                        <SortingIndicator/>
                    </HeadingWrapper>
                    {/*Monthly Rate*/}
                    <HeadingWrapper value="monthlyPayment" onClick={onHeadingClick}>
                        Monthly Rate
                        <SortingIndicator/>
                    </HeadingWrapper>
                    {/*Total Cash Price*/}
                    <HeadingWrapper value="totalCashPrice" onClick={onHeadingClick}>
                        Total Cash Price
                        <SortingIndicator/>
                    </HeadingWrapper>
                </HeadingsWrapper>
            </HeadingContent>
        </ComponentWrapper>
    );
}

ContractsLineItemHeadings.propTypes = {};
ContractsLineItemHeadings.defaultProps = {};

export default ContractsLineItemHeadings;
